/** v2 static pages (served under /version-2 after sync). */
export const ABOUT_V2_HREF = "/version-2/about/";
export const CREDITS_V2_HREF = "/version-2/credits/";
